export function merge_objects_override_keys(default_options, options_object) {
  var response_object;
  if (options_object == undefined) {
    response_object = default_options;
  } else {
    var merged_object = new Map();
    Object.entries(default_options).forEach(([key, value]) => {
      merged_object.set(key, value);
    });
    Object.entries(options_object).forEach(([key, value]) => {
      merged_object.set(key, value);
    });
    response_object = Object.fromEntries(merged_object);
  }
  return response_object;
}

export function json_parse_reviver_function_firestore(key, value) {
  if (key == "startTime" || key == "endTime" || key == "at") {
    value = value.toDate();
    return value;
  }
  return value;
}

export function json_parse_reviver_function(key, value) {
  if (key == "startTime" || key == "endTime" || key == "at") {
    value = new Date(value);
    return value;
  }
  return value;
}

export function test_if_valid_json(string) {
  try {
    JSON.parse(string);
    return true;
  } catch {
    return false;
  }
}

export const getRandomWholeNumber = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
